<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar :background-color="sidebarBackground">
      <template slot="links">
        <li v-b-toggle.report-collapse class="nav-item cursor-hover"
            :class="{ 'parent-active active': $route.name === urlConstant.name.WORKLOAD_REPORT || $route.name === urlConstant.name.PRODUCTIVITY_REPORT
             || $route.name === urlConstant.name.REPORTS || $route.name === urlConstant.name.UTILIZATION_REPORT
             || $route.name === urlConstant.name.PULL_REQUESTS || $route.name === urlConstant.name.DEVELOPER_COMPARISON || $route.name === urlConstant.name.DORA_REPORT || $route.name === urlConstant.name.PERSONAL_REPORT}">
          <div class="nav-link justify-content-between">
            <div>
              <i class="ni ni-chart-bar-32 text-primary parent-link"></i>
              <span class="nav-link-text">{{ $t('reports') }}</span>
            </div>
          </div>
        </li>
        <b-collapse id="report-collapse">
          <sidebar-item
            :class="{ 'active': $route.name === urlConstant.name.REPORTS }"
            class="nav-item-custom ml-2"
            :name-link="$t('overall_report')"
            :link="{ name: urlConstant.name.REPORTS, icon: 'ni ni-chart-bar-32 text-primary', path: urlConstant.page.REPORTS }"
          />
          <sidebar-item
            :class="{ 'active': $route.name === urlConstant.name.WORKLOAD_REPORT }"
            class="nav-item-custom ml-2"
            :name-link="$t('workload_report')"
            :link="{ name: urlConstant.name.WORKLOAD_REPORT, icon: 'ni ni-chart-bar-32 text-primary', path: urlConstant.page.WORKLOAD_REPORT }"
          />
          <sidebar-item
            :class="{ 'active': $route.name === urlConstant.name.PRODUCTIVITY_REPORT }"
            class="nav-item-custom ml-2"
            :name-link="$t('productivity_report')"
            :link="{ name: urlConstant.name.PRODUCTIVITY_REPORT, icon: 'ni ni-chart-bar-32 text-primary', path: urlConstant.page.PRODUCTIVITY_REPORT }"
          />
          <sidebar-item
            :class="{ 'active': $route.name === urlConstant.name.UTILIZATION_REPORT }"
            class="nav-item-custom ml-2"
            :name-link="$t('utilization_report')"
            :link="{ name: urlConstant.name.UTILIZATION_REPORT, icon: 'ni ni-chart-bar-32 text-primary', path: urlConstant.page.UTILIZATION_REPORT }"
          />
          <sidebar-item
            :class="{ 'active': $route.name === urlConstant.name.PULL_REQUESTS }"
            class="nav-item-custom ml-2"
            :name-link="$t('pull_requests')"
            :link="{ name: urlConstant.name.PULL_REQUESTS, icon: 'ni ni-chart-bar-32 text-primary', path: urlConstant.page.PULL_REQUESTS }"
          />
          <sidebar-item
            :class="{ 'active': $route.name === urlConstant.name.DEVELOPER_COMPARISON }"
            class="nav-item-custom ml-2"
            :name-link="$t('developer_comparison')"
            :link="{ name: urlConstant.name.DEVELOPER_COMPARISON, icon: 'ni ni-chart-bar-32 text-primary', path: urlConstant.page.DEVELOPER_COMPARISON }"
          />
          <sidebar-item
            :class="{ 'active': $route.name === urlConstant.name.DORA_REPORT }"
            class="nav-item-custom ml-2"
            :name-link="$t('dora_report')"
            :link="{ name: urlConstant.name.DORA_REPORT, icon: 'ni ni-chart-bar-32 text-primary', path: urlConstant.page.DORA_REPORT }"
          />
          <sidebar-item
            :class="{ 'active': $route.name === urlConstant.name.PERSONAL_REPORT }"
            class="nav-item-custom ml-2"
            :name-link="$t('personal_report')"
            :link="{ name: urlConstant.name.PERSONAL_REPORT, icon: 'ni ni-chart-bar-32 text-primary', path: urlConstant.page.PERSONAL_REPORT }"
          />
        </b-collapse>
        <sidebar-item
          :class="{ 'active': $route.name === urlConstant.name.INTEGRATIONS || $route.name === urlConstant.name.INTEGRATION_DETAILS }"
          class="nav-item-custom"
          :name-link="$t('integrations')"
          :link="{ name: urlConstant.name.INTEGRATIONS, icon: 'ni ni-tv-2 text-primary', path: urlConstant.page.INTEGRATIONS }"
        />
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardNavbar from './DashboardNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import { FadeTransition } from 'vue2-transitions'
import UrlConstant from '../common/url-constant'

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition
  },
  data() {
    return {
      sidebarBackground: 'vue', //vue|blue|orange|green|red|primary
      urlConstant: UrlConstant
    }
  },
  mounted() {
    const flag = this.$route.name === UrlConstant.name.WORKLOAD_REPORT || this.$route.name === UrlConstant.name.PRODUCTIVITY_REPORT
      || this.$route.name === UrlConstant.name.REPORTS || this.$route.name === UrlConstant.name.UTILIZATION_REPORT
      || this.$route.name === UrlConstant.name.PULL_REQUESTS || this.$route.name === UrlConstant.name.DEVELOPER_COMPARISON
      || this.$route.name === UrlConstant.name.REPORTS || this.$route.name === UrlConstant.name.UTILIZATION_REPORT || this.$route.name === UrlConstant.name.DORA_REPORT
      || this.$route.name === UrlConstant.name.PERSONAL_REPORT
    if (flag) {
      this.$root.$emit('bv::toggle::collapse', 'report-collapse')
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
}
</script>
<style lang="scss">
</style>
<style scoped>
  .nav-item-custom:hover {
    background-color: #F6F9FC;
  }
  .nav-item-custom:active,
  .nav-item-custom.active {
    background-color: #F6F9FC !important;
  }
  /deep/ .nav-item-custom.active a::before {
    height: 100% !important;
    top: 0 !important;
  }
  .parent-active {
    background-color: #F6F9FC !important;
  }
  .parent-link {
    min-width: 2rem;
    font-size: .9375rem;
    line-height: 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/layout/DashboardLayout.vue